import { API, API_GET_TYPE } from "../../Config";

export const GetAbout = () => {
  return API_GET_TYPE(API.getpolicy,2);
};
